import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const UnemploymentInsuranceCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [avgSalary, setAvgSalary] = useState('2.500,00');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const s = parseFloat(parseBrazilianNumber(avgSalary)) || 0;
    if (s <= 0) return;

    // Tabela 2024 (Valores estimados)
    const minWage = 1412;
    const maxBenefit = 2313.74;

    let benefit = 0;
    if (s <= 2041.39) {
      benefit = s * 0.8;
    } else if (s <= 3402.65) {
      benefit = (2041.39 * 0.8) + ((s - 2041.39) * 0.5);
    } else {
      benefit = maxBenefit;
    }

    benefit = Math.max(minWage, Math.min(maxBenefit, benefit));
    const res = { benefit };
    setResultState(res);

    onResultChange([
      { label: 'Média Salarial', value: `R$ ${s.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Valor do Benefício', value: `R$ ${benefit.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Média Salarial (últimos 3 meses)" value={avgSalary} onChange={setAvgSalary} required isNumeric type="text" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Seguro-Desemprego
          </button>
        </div>

        {resultState && (
          <ResultCard
            title="Benefício Mensal Estimado"
            value={`R$ ${resultState.benefit.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
            description="Valor por parcela"
            color="indigo"
          />
        )}
      </div>

      <EducationalBlock
        title="Regras do Seguro-Desemprego"
        tips={[
          'O valor da parcela não pode ser inferior ao salário mínimo vigente',
          'O número de parcelas varia de 3 a 5, dependendo do tempo de trabalho',
          'A média é calculada sobre os últimos 3 salários antes da demissão',
          'O teto do benefício é atualizado anualmente pelo governo'
        ]}
      />
    </div>
  );
};

export default UnemploymentInsuranceCalculator;
